<template>
  <div
    class="border rounded-lg p-2 flex gap-1 w-[170px] h-full relative"
    @click="handleDetail"
  >
    <!-- 随记 -->
    <template v-if="item.entityType === 'moment'">
      <div class="w-16 flex flex-col items-center">
        <BaseImg
          class="w-full h-full"
          fit="cover"
          v-if="moment"
          :mate="moment?.mate"
          :media="moment.mediazz[0]"
        />
      </div>

      <div class="h-full flex-1 flex flex-col gap-1">
        <div class="text-xs line-clamp-1 px-2">
          <span>{{ moment?.text }}</span>
        </div>

        <div class="flex-1">
          <div class="badge badge-ghost badge-sm">
            {{ $t(`module.timeline.${item.entityType}`) }}
          </div>
        </div>
        <!--  操作按钮 -->
        <div>
          <button class="btn btn-xs">
            {{ $t(`module.timeline.detail`) }}
          </button>
        </div>
      </div>
    </template>

    <!-- 故事 -->
    <template v-if="item.entityType === 'storyBook'">
      <div class="w-16 flex flex-col items-center rounded-sm overflow-hidden">
        <BaseImg :url="storybook?.media?.url" />
        <div class="bg-base-200 w-full flex justify-center items-center">
          <Logo class="w-7 h-5" />
        </div>
      </div>

      <div class="flex-1 flex flex-col gap-1">
        <div class="text-xs line-clamp-1 px-2">
          <span>{{ storybook?.title }}</span>
        </div>

        <div class="flex-1">
          <div class="badge badge-ghost badge-sm">
            {{ $t(`module.timeline.${item.entityType}`) }}
          </div>
        </div>

        <!--  操作按钮 -->
        <div>
          <button class="btn btn-xs">
            {{ $t(`module.timeline.detail`) }}
          </button>
        </div>
      </div>
    </template>

    <!-- OC -->
    <template v-if="item.entityType === 'mate'">
      <div class="w-16 flex flex-col items-center">
        <BaseImg v-if="mate" :mate="mate" />
      </div>
      <div class="flex-1 flex flex-col gap-1">
        <div class="text-xs line-clamp-1 px-2">{{ mate?.name }}</div>
        <div class="flex-1">
          <div class="badge badge-ghost badge-sm">
            {{ $t(`module.timeline.${item.entityType}`) }}
          </div>
        </div>
        <div>
          <button class="btn btn-xs">
            {{ $t(`module.timeline.ocCard`) }}
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { TimelineEventItem } from "@/types/entity";
import { Mate, Moment, StoryBook } from "@/types/entity";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

const props = defineProps<{
  mode: "edit" | "preview" | "sort";
  item: TimelineEventItem;
}>();

const moment = ref<Moment>();
const storybook = ref<StoryBook>();
// const collection = ref<Collection>();
// const worldview = ref<Worldview>();
const mate = ref<Mate>();

const router = useRouter();

onMounted(() => {
  if (props.item.entityType === "moment") {
    moment.value = props.item.entity as Moment;
  } else if (props.item.entityType === "storyBook") {
    storybook.value = props.item.entity as StoryBook;
  } else if (props.item.entityType === "mate") {
    mate.value = props.item.entity as Mate;
  }
});

const handleDetail = () => {
  console.log(props.item);
  if (props.item.entityType === "moment") {
    router.push({
      name: "threadDetail",
      params: {
        uuid: props.item.entity.uuid,
      },
    });
  } else if (props.item.entityType === "storyBook") {
    router.push({
      name: "storyBookHome",
      params: {
        uuid: props.item.entity.uuid,
      },
    });
  } else if (props.item.entityType === "mate") {
    router.push({
      name: "mateHome",
      params: { uuid: props.item.entity.uuid },
    });
  }
};

// const clickDelete = () => {
//   console.log(props.item);
// };
</script>
